import { defineComponent } from 'vue';
export default defineComponent({
    name: 'DropDown',
    data: () => ({
        id: `dropDownDefault${Math.random()}`
    })
});
